<template>
    <div>
        <div class="leaderBox" v-if="showOrhide">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
            <img src="../../../assets/images/pop/tjlb/tjlb1.jpg" class="steps step1" v-if="status==1">
            <img src="../../../assets/images/pop/tjlb/tjlb2.jpg" class="steps step2" v-if="status==2" >
            <div class="stepbtn" @click="nextStep(status)">
                {{status==1?"下一步":status==2?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked">下次不再提示</el-checkbox>
            </div>
        </div>
        <!--        <breadcrumb :routerList="[{to:'/pricenewN',title:'特价管理'},{title:'特价列表'}]"/>-->
        <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox zhi">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <el-form-item label="年月" prop="searchDate">
                            <div class="block">
                                <el-date-picker
                                        v-model="formInline.searchDate"
                                        type="month"
                                        placeholder="选择月"
                                        value-format="yyyy-MM">
                                </el-date-picker>
                            </div>
                        </el-form-item>

                        <el-form-item label="领域" prop="field">
                            <brselect category="swyl_field_new" :v="formInline.field" :showcode="true"
                                      v-model="formInline.field" clearable></brselect>
                        </el-form-item>

                        <el-form-item label="特价类型" prop="specialCategory">
                            <brselect category="category_tejia" :v="formInline.specialCategory" :showcode="true" :multiple="true"
                                      v-model="formInline.specialCategory" clearable></brselect>
                        </el-form-item>

                        <el-form-item label="区域" prop="area_code">
                            <brselect category="YLRegion" :v="formInline.areaCode" v-model="formInline.areaCode" :multiple="true"
                                      :clearable="true"
                                      style="width:100%"/>
                        </el-form-item>

                        <el-form-item label="链群" prop="lianqun">
                            <el-select v-model="formInline.lianqun" :clearable="true"
                                       placeholder="请选择">
                                <el-option label="传统" value="传统"></el-option>
                                <el-option label="血液" value="血液"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-screen" @click="collapseChange">
                            <img :src="isScreen?closeScreen:drawScreen" alt="">
                            <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                        </div>
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn"  v-if="caiwu || admin" @click="calResource">本月资源池计算</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row">
<!--                <div class="h-mrt30 margin">-->
<!--                    <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">当月可用资源池=导入数据+T-1累计结余+本月预借-T-1月累计预借+订单项目退回</h6>-->
<!--                    <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">①当月导入资源池=当月收入预测*资源池基数</h6>-->
<!--                    <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;">②T-1月累计结余=T-1月累计应可用金额-T-1月累计已使用金额</h6>-->
<!--                </div>-->
                <div class="resourcePoolTable" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            :data="tableData2"
                            border
                            stripe
                            show-summary
                            :summary-method="getSummaries"
                            max-height="450"
                            style="width: 100%"
                    >
                        <el-table-column
                                type="selection"
                                width="45"
                                label="全选"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                fixed
                                label="#">
                        </el-table-column>
                        <el-table-column
                                prop="year"
                                label="年"
                                fixed
                                :show-overflow-tooltip="true"
                                width="60">
                            <template scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.year}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="month"
                                label="月"
                                fixed
                                :show-overflow-tooltip="true"
                                min-width="40">
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.month}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="areaName"
                                label="区域"
                                fixed
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.areaName}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="specialCategory"
                                label="特价类型"
                                fixed
                                :show-overflow-tooltip="true"
                                width="90"
                        >
                            <template slot-scope="scope" >
                                {{scope.row.specialCategory|dictname('category_tejia')}}
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="importMoney"
                                label="导入金额"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.importMoney}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="lastBalance"
                                label="上月结余"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.lastBalance}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="imprest"
                                label="本月预借"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.imprest}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="supplyMoney"
                                label="补足资源池亏损金额"
                                width="100"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="lastImprest"
                                label="上月预借"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="accumulateImprest"
                                label="累计预借"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="releaseMoney"
                                label="之前释放金额"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="resourcePool"
                                label="资源池金额"
                                width="100"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="useMoney"
                                width="100"
                                label="本月实际使用金额">
                        </el-table-column>
                        <el-table-column
                                prop="balance"
                                sortable
                                width="100"
                                label="账户结余">
                        </el-table-column>
                        <el-table-column
                                prop="base"
                                sortable
                                v-if="this.caiwu || this.admin"
                                width="100"
                                label="资源池点位">
                        </el-table-column>
                        <el-table-column
                                prop="allocateBase"
                                sortable
                                v-if="this.caiwu || this.admin"
                                width="100"
                                label="本月自挣调配点位">
                        </el-table-column>
                        <el-table-column
                                prop="policyMoney"
                                sortable
                                v-if="this.caiwu || this.admin"
                                width="100"
                                label="政策使用金额">
                        </el-table-column>
                        <el-table-column
                                prop="lianqun"
                                label="链群"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    {{scope.row.lianqun}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                :show-overflow-tooltip="true"
                                width="80"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                label="创建时间"
                                :formatter="formatDate"
                                :show-overflow-tooltip="true"
                                width="100"
                        >
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                fixed="right"
                                width="200"
                        >
                            <template slot-scope="scope">
                                <div class="w-caozuo" style="text-align: left;">
                                    <el-button
                                            type="text"
                                            size="small"
                                            v-if="caiwu || admin"
                                            class="h-tableLink h-btn" @click="updatePool(scope.row)">
                                        修改
                                    </el-button>
                                </div>


                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="h-tableB h-mrt30" style="padding-right: 0.12rem;">
                <div class="h-tableBL">
<!--                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>-->
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="caiwu || admin"
                               @click="uploaddownexcelflagbtn1">批量导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="caiwu || admin"
                               @click="uploaddownexcelflagbtn">政策金额导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>

                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="caiwu || admin || xueye"
                               @click="uploaddownexcelflagbtn2">区域资源调配导入
                    </el-button>
                    <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" v-if="caiwu || admin || xueye"
                               @click="uploaddownexcelflagbtn3">资源池调增调减
                    </el-button>

                    <uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag"
                                     clsname="orderResourcePoolPolicyExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag1" v-if="uploaddownexcelflag1"
                                     clsname="orderResourcePoolExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag2" v-if="uploaddownexcelflag2"
                                     clsname="orderResourcePoolChangeExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                    <uploaddownexcel :visible.sync="uploaddownexcelflag3" v-if="uploaddownexcelflag3"
                                     clsname="orderResourcePoolAddOrSubtractExcel"
                                     :startrow="1" @callback="uploadExcelFilecallback"/>
                </div>
                <div class="h-pagination2 h-pageCenter">
                    <pagination :page="formInline" @query="query"/>
                </div>
            </div>
            <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="updateVisDialogFlag" class="h-dialog2">
                <div class="h-dialogImg">
                    <div class="h-disTable">
                        <div class="h-tableCell">
                            <h1>{{uptitleDig}}</h1>
                        </div>
                    </div>
                </div>
                <div class="h-formLines">
                    <el-form ref="form" :model="up" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">

                        <el-form-item label="年" class="h-elformWrap-2" prop="year">
                            <el-input v-model="up.year" disabled style="width: 70%;"></el-input>
                        </el-form-item>

                        <el-form-item label="月" class="h-elformWrap-2" prop="month">
                            <el-input v-model="up.month" disabled style="width: 70%;"></el-input>
                        </el-form-item>

                        <el-form-item  label="领域" class="h-elformWrap-2" label-width="100" prop="field" >
                            <brselect category="swyl_field_new" :v="up.field" style="width: 70%;" :showcode="true" disabled v-model="up.field" clearable></brselect>
                        </el-form-item>

                        <el-form-item label="渠道" class="h-elformWrap-2" prop="channels">
                            <el-input v-model="up.channels" style="width: 70%;"></el-input>
                        </el-form-item>

                        <el-form-item  label="特价类型" class="h-elformWrap-2" label-width="100" prop="specialCategory" >
                            <brselect category="category_tejia" :v="up.specialCategory" style="width: 70%;" :showcode="true" disabled v-model="up.specialCategory" clearable></brselect>
                        </el-form-item>

                        <el-form-item label="导入金额" class="h-elformWrap-2" required prop="importMoney">
                            <el-input v-model="up.importMoney" style="width: 70%;"></el-input>
                        </el-form-item>

                        <el-form-item label="上月结余" class="h-elformWrap-2" required prop="importMoney">
                            <el-input v-model="up.lastBalance" style="width: 70%;"></el-input>
                        </el-form-item>

                    </el-form>
                    <div style="display:flex;justify-content:center;margin-bottom:20px">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">提交</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    import updownfile from '../../../utils/updownfile'
    export default {
        components: {
            uploaddownexcel,
            updownfile,
        },
        data() {
            return {
                closeScreen:require("@/assets/images/pimg/closeallic.png"),
                drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                tableData2:[],
                formInline: {
                    searchDate:null,
                    field: null,
                    lianqun:'传统',
                    specialCategory: null,
                    areaCode:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                up:{
                    id: null,
                    field: null,
                    specialCategory: null,
                    year: null,
                    month: null,
                    importMoney: null,
                    lastBalance: null,
                    channels:null,
                },
                uploaddownexcelflag:false,
                uploaddownexcelflag1:false,
                uploaddownexcelflag2:false,
                uploaddownexcelflag3:false,
                showOrhide:false,
                updateVisDialogFlag:false,
                uptitleDig: null,
                caiwu:false,
                admin:false,
                xueye:false,
                isScreen: false,
            }
        },
        //加载页面默认执行
        created() {
            this.caiwu = this.$store.getters.hasRole('swyl_ylcs_caiwu') || this.$store.getters.hasRole('swyl_caiwujl');
            this.admin = this.$store.getters.hasRole('swyl_admin');
            this.xueye = this.$store.getters.hasRole('swyl_resource_pool_xuye');
            this.formInline.searchDate = this.dateFormatter(new Date());
            this.query();
        },
        mounted() {

        },
        methods: {
            /*// 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },*/
            showzhezhao(){
                ss.salesList.toshow(this.toshow).then(rd => {
                    console.log(rd)
                    if(rd == false){
                        this.showOrhide = false;
                    }else{
                        this.showOrhide = true;
                    }
                })
            },
            //重置
            resetData(){
                this.formInline.field = null;
                this.formInline.specialCategory = null;
                this.query();
            },
            //检索
            query(){
                ss.resourcePool.selectPage(this.formInline).then(rd => {
                    this.tableData2 = rd.records;
                    this.formInline.total = rd.total;
                })
            },
            //修改
            updatePool(v){
                this.up.id = v.id;
                this.up.field = v.field;
                this.up.specialCategory = v.specialCategory;
                this.up.year = v.year;
                this.up.month = v.month;
                this.up.importMoney = v.importMoney;
                this.up.lastBalance = v.lastBalance;
                this.up.channels = v.channels;
                this.updateVisDialogFlag = true;
                this.uptitleDig = '资源池导入金额修改';
                // ss.resourcePool.checkUpdate(v).then(rd => {
                //     if(rd.msg == true){
                //
                //     }else {
                //         this.$msg.msge("超过可调整资源池金额时间，不允许调整！");
                //         return;
                //     }
                // })
            },
            //取消
            exit() {
                this.closeDialog()
            },
            //重置
            closeDialog(){
                this.updateVisDialogFlag = false;
                this.up.id = null;
                this.up.field = null;
                this.up.specialCategory = null;
                this.up.year = null;
                this.up.month = null;
                this.up.importMoney = null;
                this.up.lastBalance = null;
                this.up.channels = null;
            },
            commitUpdate(){
                var data = {
                    id: null,
                    importMoney: null,
                    searchDate:null,
                    lastBalance:null,
                }
                data.id = this.up.id;
                data.importMoney = this.up.importMoney;
                data.lastBalance = this.up.lastBalance;
                data.searchDate = this.up.year + "-" + this.up.month;
                ss.resourcePool.updateById(data).then(rd => {
                    if(rd.f){
                        this.query();
                        this.closeDialog();
                    }
                })
            },
            //导入
            uploaddownexcelflagbtn() {
                this.uploaddownexcelflag = true;
            },

            uploaddownexcelflagbtn1() {
                this.uploaddownexcelflag1 = true;
            },
            uploaddownexcelflagbtn2() {
              this.uploaddownexcelflag2 = true;
            },
            uploaddownexcelflagbtn3() {
                this.uploaddownexcelflag3 = true;
            },
            uploadExcelFilecallback() {
                this.query();
            },
            //明细导出
            exportExcel() {
                updownfile.down("/api/swyl/v1/resourcePool/downloadExcel",this.formInline,"post",'data');
            },
            dateFormatter(v){
                var now = new Date(v);
                var year=now.getFullYear();
                var month = now.getMonth()+1 < 10?'0'+(now.getMonth()+1) : now.getMonth()+1;
                var alldata2 =  year+"-"+month;
                return alldata2;
            },
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null || data == '') {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
            // 展开折叠
            collapseChange(){
                this.isScreen = !this.isScreen;
            },
            //计算本月数据
            calResource(){
                ss.resourcePool.calResource(this.formInline).then(rd => {
                    if(rd.f){
                        this.query();
                    }
                })
            },
            getSummaries(param) {
                const { columns, data } = param;//这里可以看出，自定义函数会传入每一列，以及数据
                const sums = [];
                columns.forEach((column, index) => {
                    if (index == 1) {
                        sums[index] = data.length + 1;
                    }else if(index == 2){
                        sums[index] = '总计';
                    }else if (index == 6||index == 7||index == 8||index == 9||index == 10||
                        index == 11||index == 12||index == 13||index == 14||index == 17||index == 15) { //index>=3后的列进行求和
                        //页面分别统计 处理
                        if(index == 14){
                            let newData = [];
                            for(var i = 0;i<data.length;i++) {
                                if (data[i].areaName != '平台') {
                                    newData.push(data[i])
                                }
                            }
                            const values = newData.map(item => Number(item[column.property]));
                            if (!values.every(value => isNaN(value))) {
                                sums[index] = values.reduce((prev, curr) => {
                                    const value = Number(curr);
                                    if (!isNaN(value)) {
                                        return prev + curr ;
                                    } else {
                                        return prev;
                                    }
                                }, 0);
                                //此处结合了方式一的判断处理，实现多种条件处理
                                //此处的column.property获取的值对应<el-table-column>中prop对应的字段
                                sums[14] =  Number(sums[14]).toFixed(2);

                            } else {
                                sums[index] = ''; //如果列的值有一项不是数字，就显示这个自定义内容
                            }
                        }else {
                            const values = data.map(item => Number(item[column.property]));
                            if (!values.every(value => isNaN(value))) {
                                sums[index] = values.reduce((prev, curr) => {
                                    const value = Number(curr);
                                    if (!isNaN(value)) {
                                        return prev + curr ;
                                    } else {
                                        return prev;
                                    }
                                }, 0);
                                //此处结合了方式一的判断处理，实现多种条件处理
                                //此处的column.property获取的值对应<el-table-column>中prop对应的字段
                                sums[15] =  Number(sums[15]).toFixed(2);
                                sums[6] =  Number(sums[6]).toFixed(2);
                                sums[7] =  Number(sums[7]).toFixed(2);
                                sums[8] =  Number(sums[8]).toFixed(2);
                                sums[9] =  Number(sums[9]).toFixed(2);
                                sums[10] =  Number(sums[10]).toFixed(2);
                                sums[11] =  Number(sums[11]).toFixed(2);
                                sums[12] =  Number(sums[12]).toFixed(2);
                                sums[13] =  Number(sums[13]).toFixed(2);
                                sums[14] =  Number(sums[14]).toFixed(2);
                                sums[17] =  Number(sums[17]).toFixed(2);

                            } else {
                                sums[index] = ''; //如果列的值有一项不是数字，就显示这个自定义内容
                            }
                        }

                    }else {
                        sums[index] = ''
                    }
                });
                return sums;//最后返回合计行的数据
            },
        }
    }
</script>
<style scoped>
    .selectorBox {
        width: 100%;
        padding: 0.54rem 0.28rem 0 0.25rem;
    }
    .selectorBox .text {
        margin-left: 0.38rem;
        font-size: 0.18rem;
        color: #4a4a4a;
        position: relative;
    }
    .selectorBox .text::before {
        content: "*";
        position: absolute;
        top: 0;
        left: -7px;
        color: red;
        font-size: 0.2rem;
    }
    .selectorBox .selector {
        margin-left: 0.38rem;
        margin-top: 20px;
        display: flex;
    }
    .selectorBox .selector .button {
        width: 65px;
        padding: 10px;
        color: #b7b7b7;
        border: 1px solid #dcdfe1;
        text-align: center;
        line-height: 20px;
        cursor: pointer;
    }
    .selectorBox .selector .button.active {
        color: #fff;
        background: #238cfd;
        border: 1px solid #238cfd;
    }
    .T-jia .h-btn.el-button.h-tableLink{
        padding: 0 0.05rem;
    }
    #xcv {
        padding: 0.14rem 0.2rem;
        font-size: 0.18rem;
        color: #fff;
        letter-spacing: 0.02rem;
        border: 1px solid #24b5b8;
        background: #24b5b8;
        border-radius: 0.04rem;
        line-height: 0.18rem;
    }
</style>
<style>
    .X-la .h-formbLine .el-form-item__content .el-select{
        width: 100%!important;
    }
    .zhi .el-date-editor .el-range-separator{
        width:13%;
        margin-bottom:7px;
    }
    .selectorBox .el-input-group__append {
        background: #238cfd;
        color: #fff
    }
    .selectorBox .el-upload-list {
        display: none;
    }

</style>
<style scoped lang="scss">
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
        z-index: 999999;
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0;
            left: 0;

        }
        .step2{
            top: 0;
            right: 0;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
            z-index: 2;
        }
    }
</style>
